//#region src/location_mode_deprecated.ts
var LocationModeDeprecated = /* @__PURE__ */ function(LocationModeDeprecated) {
	LocationModeDeprecated[LocationModeDeprecated["Standalone"] = 1] = "Standalone";
	LocationModeDeprecated[LocationModeDeprecated["PosI9n"] = 2] = "PosI9n";
	return LocationModeDeprecated;
}(LocationModeDeprecated || {});
//#endregion
export { LocationModeDeprecated };

//# sourceMappingURL=location_mode_deprecated.js.map